import React from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../config/index';
import {connect, setStore} from "trim-redux";
import {withRouter} from 'react-router-dom';
import { withSnackbar } from 'notistack';
import LoadingButton from "../../components/elements/LoadingButton";
import Typography from "@material-ui/core/Typography/Typography";
import Button from "@material-ui/core/Button/Button";
import HeaderTags from "../../components/elements/HeaderTags";
import Box from "@material-ui/core/Box/Box";
import AuthLayout from "../../components/layouts/AuthLayout";
import ChangeMobileModal from "./components/ChangeMobileModal";

class MobileVerify extends React.Component {
    constructor(props){
        super(props);
        let user = this.props.user;
        if(user.mobile_confirmed === 1){
            this.props.history.push('/')
        }
        this.state={
            fields: {
                token:0,
            },
            errors:{},
            SubmitLoading:false,
            success:false,
            minutes: 3,
            seconds: 0,
        };
    }
    async componentDidMount(){
        await this.makeToken();

    }
    componentWillUnmount() {
        clearInterval(this.myInterval)
    }
    async makeToken(){
        const loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`

            }
        };
        await axios.get(`${defaultVariabls.url}/user/makeToken`, config)
            .then(response =>{
                    this.setState({
                        minutes:3,
                        seconds:0
                    })
                this.myInterval = setInterval(() => {
                    const { seconds, minutes } = this.state

                    if (seconds > 0) {
                        this.setState(({ seconds }) => ({
                            seconds: seconds - 1
                        }))
                    }
                    if (seconds === 0) {
                        if (minutes === 0) {
                            clearInterval(this.myInterval)
                        } else {
                            this.setState(({ minutes }) => ({
                                minutes: minutes - 1,
                                seconds: 59
                            }))
                        }
                    }
                }, 1000)
            })
            .catch(error =>{
                console.log(error.response)
                this.setState({
                    SubmitLoading:false

                })
                this.props.enqueueSnackbar(Translate.makingTokenError, {
                    variant: 'error',
                });
            });
    }
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({fields});
        if(fields['token'].length === 5) {
            this.setState({
                SubmitLoading:true
            })
            this.handleRequest()
        }
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;

        //token
        if(validator.isEmpty(fields.token)){
            formIsValid = false;
            errors['token'] = Translate.emptyField;
        }
        this.setState({errors},() =>{
            if(!formIsValid){
                this.setState({
                    SubmitLoading:false
                })
            }
            return callback(formIsValid)
        });
    }
    handleLogout(){
        localStorage.removeItem('ACT');
        localStorage.removeItem('RET');
        setStore({
            isAuth : false,
            user : null,
        });
        window.location.replace(`${defaultVariabls.website}/logOutFromPanel`);
    }
    async handleRequest(){
        const {token} = this.state.fields;
        const loginToken = localStorage.getItem('ACT');
        let data = new FormData();
        data.append('token', token);
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`

            }
        };
        await axios.post(`${defaultVariabls.url}/user/checkToken`, data, config)
            .then(response =>{
                this.props.enqueueSnackbar(Translate.mobileVerified, {
                    variant: 'success',
                });
                setStore({
                    isAuth : true,
                    user : response.data,
                });
                window.location.replace(`${defaultVariabls.React}`);
            })
            .catch(error =>{
                this.setState({
                    SubmitLoading:false

                })
                this.props.enqueueSnackbar(Translate.wrongToken, {
                    variant: 'error',
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        })
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }
        });
    }

    render() {
        const {classes} = this.props;
        const {errors,SubmitLoading,success,minutes,seconds} = this.state;
        return (
            <AuthLayout>
                <HeaderTags title={Translate.mobileVerify}/>

                <Grid item md={10} lg={8}>
                    <Box mb={{xs: 3, xl: 8}}  fontSize={18}>
                        <strong> {Translate.mobileVerify}</strong>
                    </Box>
                    <form className={classes.form} noValidate onSubmit={this.handleSubmit.bind(this)}>
                        <Grid container spacing={1} justify="center" alignItems='center'>
                            <Grid item xs={12}>
                                <TextField
                                    autoFocus
                                    required
                                    fullWidth
                                    variant="outlined"
                                    id="token"
                                    label={Translate.token}
                                    name="token"
                                    margin="normal"
                                    onChange={this.handleChange.bind(this)}
                                    error = {!!errors['token']}
                                    helperText={errors['token']}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Typography align="left" color="textSecondary">
                                    {Translate.sendTokenText1} <strong>{this.props.user.mobile}</strong> {Translate.sendTokenText2}
                                    <ChangeMobileModal/>
                                </Typography>
                                {
                                    minutes !== 0 || seconds !== 0 ? <Typography align="left" color="textSecondary">{Translate.sendTokenText3}: <strong>{minutes}:{seconds < 10 ? `0${seconds}` : seconds}</strong> </Typography> : <Button color="primary" onClick={this.makeToken.bind(this)}>{Translate.sendAgain}</Button>
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <LoadingButton
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    style={{width:"100%"}}
                                    onClick = {this.handleSubmit.bind(this)}
                                    loading = {SubmitLoading}
                                    success = {success}
                                >
                                    {Translate.confirm}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs>
                                <Typography onClick={this.handleLogout.bind(this)} className="withCursor" variant="body2" color="primary"> {Translate.logOut}</Typography>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </AuthLayout>
        );

    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(MobileVerify))));